import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { RippleModule } from 'primeng/ripple';

import { MarkdownHelpComponent } from './markdown-help.component';

@NgModule({
  declarations: [MarkdownHelpComponent],
  imports: [CommonModule, ButtonModule, DynamicDialogModule, RippleModule],
  exports: [MarkdownHelpComponent],
})
export class MarkdownHelpModule {}
